import { render, staticRenderFns } from "./MailNotifyGroup.vue?vue&type=template&id=24ca51c9&"
import script from "./MailNotifyGroup.vue?vue&type=script&lang=ts&"
export * from "./MailNotifyGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports